import { getCookie, setCookie } from "../helper/helper";

export function initColorMode() {
  const body = document.body;
  const colorSchemeQueryList = window.matchMedia(
    "(prefers-color-scheme: dark)"
  );
  const schemeSwitch = document.getElementById("color-mode-switch");

  /**
   * Set color scheme based on system preference
   */
  const setColorScheme = (e) => {
    let scheme = "dark";
    const schemeCookie = getCookie("color_mode");

    if (e) {
      scheme = e.matches ? "dark" : "light";
    }

    if (schemeCookie) {
      scheme = schemeCookie;
      body.dataset.scheme = schemeCookie;
    }

    if (scheme == "light") {
      schemeSwitch.checked = true;
    } else {
      schemeSwitch.checked = false;
    }
  };

  setColorScheme(colorSchemeQueryList);

  /**
   * On toggle theme switch
   */
  schemeSwitch.addEventListener("change", function () {
    if (this.checked) {
      body.dataset.scheme = "light";
      setCookie("color_mode", "light", 365);
    } else {
      body.dataset.scheme = "dark";
      setCookie("color_mode", "dark", 365);
    }
  });

  /**
   * On system color scheme change
   */
  colorSchemeQueryList.addEventListener("change", setColorScheme);
}
